import React from 'react';
import Title from './Title';
import ProgressBar from './ProgressBar';
import Bubbles from './Bubbles';

const skills = [
  { id: 1, percent: 95, label: "JavaScript", color: "from-yellow-500 to-accent" },
  { id: 2, percent: 92, label: "React / Next.js", color: "from-cyan-500 to-accent" },
  { id: 3, percent: 88, label: "Node.js", color: "from-green-500 to-accent" },
  { id: 4, percent: 85, label: "TypeScript", color: "from-blue-500 to-accent" },
  { id: 5, percent: 85, label: "PHP / Laravel", color: "from-red-500 to-accent" },
  { id: 6, percent: 80, label: "Python", color: "from-emerald-500 to-accent" },
  { id: 7, percent: 75, label: "AI / ML Integration", color: "from-purple-500 to-accent" },
  { id: 8, percent: 90, label: "HTML / CSS", color: "from-orange-500 to-accent" },
  { id: 9, percent: 82, label: "System Architecture", color: "from-indigo-500 to-accent" },
  { id: 10, percent: 78, label: "DevOps / Cloud", color: "from-sky-500 to-accent" },
  { id: 11, percent: 80, label: "Database Design", color: "from-amber-500 to-accent" },
  { id: 12, percent: 85, label: "Team Leadership", color: "from-rose-500 to-accent" },
];

const Skill = () => {
  return (
    <section id="skills" className="relative bg-primary-bg py-24 overflow-hidden noise-overlay">
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-30" />
      <Bubbles count={5} />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Title>Technical Skills</Title>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-2">
          {skills.map(({ id, percent, label, color }) => (
            <ProgressBar key={id} id={id} percent={percent} label={label} color={color} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Skill
